import { errorHandler } from '../../middleware'
import smartAuthAPI from '../smartbestbuys-api'
import { CreatedProduct, ProductCreationRequest } from './types'

export const createProductAPI = errorHandler<CreatedProduct>((request: ProductCreationRequest) => {
  const path = `/products`
  return smartAuthAPI.post(path, request)
})
